var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 90"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 14",
    cx: 38.8243,
    cy: 39.4729,
    rx: 38.8243,
    ry: 38.8243,
    fill: "#425893"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ELEMENTS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.8581 43.2911L48.9584 36.3003H42.1806V31.7563C42.1806 29.8447 43.1269 27.9768 46.1527 27.9768H49.2775V22.0237C47.4577 21.7335 45.619 21.5765 43.7761 21.554C38.1976 21.554 34.5557 24.9074 34.5557 30.9698V36.3003H28.3721V43.2911H34.5557V60.2002H42.1806V43.2911H47.8581Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a960d9a904e0d37ce9b485cab8b8cfe8.svg";
export { ForwardRef as ReactComponent };